// Quick View Alpine component — auto-bundled via main.js
// Per-page visibility config injected by quick_view_variant_1.jinja into #quick-view-config

const _qvConfigEl = document.getElementById('quick-view-config');
const _qvConfig = _qvConfigEl
    ? JSON.parse(_qvConfigEl.textContent)
    : { visibility: {}, badgePosition: 'top-right' };

if (typeof window.quickViewModal === 'undefined') {
    window.quickViewModal = function () {
        return {
            open: false,
            product: null,
            visibility: _qvConfig.visibility || {},
            badgePosition: _qvConfig.badgePosition || 'top-right',

            init() {
                if (performance.navigation.type === 2 || window.history.state !== null) {
                    this.open = false;
                }
                this.$watch('open', (value) => {
                    document.body.style.overflow = value ? 'hidden' : '';
                });
            },

            openQuickView(data) {
                this.product = data;
                this.open = true;
            },

            closeQuickView() {
                this.open = false;
                setTimeout(() => { this.product = null; }, 300);
            },

            hasValidPrice(price) {
                if (!price) return false;
                const priceStr = String(price).trim();
                return priceStr && priceStr !== '0' && priceStr !== '0.00';
            },

            renderTitle(title) {
                if (!title) return '';
                if (typeof title === 'object' && title.en) return title.en;
                return String(title);
            },

            renderText(text) {
                if (!text) return '';
                if (typeof text === 'object' && text.en) return text.en;
                if (typeof text === 'object') return '';
                return String(text);
            },

            decodeBase64(str) {
                if (!str || typeof str !== 'string') return '';
                try {
                    return decodeURIComponent(escape(atob(str)));
                } catch (e) {
                    return str;
                }
            },

            stripHtml(html) {
                if (!html) return '';
                // Preserve <br> as newlines before stripping tags
                const withBreaks = html.replace(/<br\b[^>]*\/?>/gi, '\n');
                const tmp = document.createElement('div');
                tmp.innerHTML = withBreaks;
                return (tmp.textContent || tmp.innerText || '').trim();
            },

            getDescription() {
                if (!this.product || !this.product.description) return '';
                const desc = this.product.description;
                let rawDesc = '';
                if (typeof desc === 'string') {
                    rawDesc = desc;
                } else if (typeof desc === 'object' && desc !== null) {
                    rawDesc = desc.en || '';
                }
                if (!rawDesc) return '';
                let plainText = this.stripHtml(this.decodeBase64(rawDesc)).trim();
                if (plainText.length > 400) plainText = plainText.substring(0, 400) + '...';
                return plainText;
            },

            hasDescription() {
                return !!this.getDescription();
            },

            hasValidText(text) {
                if (!text) return false;
                if (typeof text === 'object' && text.en) return !!text.en.trim();
                if (typeof text === 'object') return false;
                return !!String(text).trim();
            }
        };
    };
}
